var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collections"},[_c('v-header',{attrs:{"breadcrumb":[
      {
        name: _vm.$t('collections'),
        path: '/collections'
      }
    ],"icon":"box"}}),(_vm.items.length === 0)?_c('v-error',{attrs:{"title":_vm.$t('no_collections'),"body":_vm.$t('no_collections_body'),"icon":"error_outline"}}):_c('div',{staticClass:"padding"},[_c('v-table',{attrs:{"items":_vm.items,"columns":_vm.fields,"primary-key-field":"collection","link":"__link__"},on:{"select":_vm.select}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }